import React from "react";
import "./Policy.css";

export default function PrivacyPolicy() {
  return (
    <div className="policy-container">
      <h1>Privacy Policy</h1>
      <p>Last updated: April 18, 2025</p>
      <p>We respect your privacy. We collect and store:</p>
      <ul>
        <li>Game transcripts & audio for analysis.</li>
        <li>Usage data to improve the product.</li>
      </ul>
      <p>
        We do <b>not</b> share or sell your data.
      </p>
      <p>All subscriptions are non-refundable.</p>
      <p>Contact grandmasterai.com@gmail.com</p>
    </div>
  );
}
